import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import media from 'src/styles/media';

const List = ({ plans, filters, onClickPlan, type }) => {
  const handleClick = plan => {
    onClickPlan(plan);
  };

  const renderFilterGroup = (filter, index) => {
    const items = plans.filter(plan => {
      for (const key of Object.keys(filter.filters)) {
        if (!filter.filters[key]) {
          if (plan[key]) {
            return false;
          }
        } else if (plan[key] !== filter.filters[key]) {
          return false;
        }
      }
      return true;
    });

    if (!items.length) {
      return null;
    }

    return (
      <FilterGroup key={`${type}${index}`} style={{animationDelay: `${index * 0.15}s`}}>
        <h4>{filter.label}</h4>
        <ItemsContainer>
          {items.map(item => (
            <Item
              key={item.id}
              onClick={() => {
                handleClick(item);
              }}
            >
              {item.id}
            </Item>
          ))}
        </ItemsContainer>
      </FilterGroup>
    );
  };

  return (
    <Root>
      {filters.map((filter, index) => {
        return renderFilterGroup(filter, index);
      })}
    </Root>
  );
};

List.propTypes = {
  plans: PropTypes.array,
  filters: PropTypes.array,
  onClickPlan: PropTypes.func,
};

List.defaultProps = {
  plans: [],
  filters: [],
  onClickPlan: f => f,
};

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const animateFilterGroup = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const FilterGroup = styled.div`
  width: 50%;
  opacity: 0;
  animation: ${animateFilterGroup} 1s forwards;
  h4 {
    padding: 20px 10px 10px;
    margin-top: 15px;
    margin-bottom: 15px;
    color: #4A4A4A;
    font-family: ${({theme}) => theme.fontMedium};
    font-size: 12px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
  }
  @media (max-width: ${media.sm}) {
    width: 100%;
  }
`;

const Item = styled.div`
  width: 70px;
  height: 70px;
  border: 2px solid ${({ theme }) => theme.colorPrimary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 1px;
  color: ${({ theme }) => theme.colorPrimary};
  cursor: pointer;
  margin: 0 10px 20px;
  transition: all 0.25s;
  &:hover {
    color: #fff;
    background: ${({ theme }) => theme.colorBackground};
  }
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

export default List;



// WEBPACK FOOTER //
// ./src/pages/Plans/elements/List.js